









import 'reflect-metadata'
import { Vue, Component } from 'vue-property-decorator'
import Price from '@/components/ActionChain/Infos/Price.vue'
import Fees from '@/components/ActionChain/Infos/Fees.vue'
import Gas from '@/components/ActionChain/Infos/Gas.vue'
import LatestBlock from '@/components/ActionChain/Infos/LatestBlock.vue'
import MarketCap from '@/components/ActionChain/Infos/MarketCap.vue'
import TransactionHistory from '@/components/ActionChain/Infos/TransactionHistory.vue'
import Transactions from '@/components/ActionChain/Infos/Transactions.vue'

@Component({
    components: {
        Price,
        Fees,
        Gas,
        LatestBlock,
        MarketCap,
        TransactionHistory,
        Transactions,
    },
})
export default class Stats extends Vue {}
